import { lazy } from "react";
import { Paths } from "./Paths";

export const INVESTOR = "INVESTOR";
export const DEALER = "DEALER";
export const ADMIN = "ADMIN";
export const ROLES = { INVESTOR, DEALER, ADMIN };

export const privateRoutes = {
  super_admin: [
    {
      path: Paths.home,
      ComponentIn: lazy(() => import("Components/Admin/home/index"))
    },
    {
      path: Paths.home + "/view",
      ComponentIn: lazy(() => import("Components/Admin/home/view"))
    },
    {
      path: Paths.home + "/update",
      ComponentIn: lazy(() => import("Components/Admin/home/update"))
    },
    {
      path: Paths.allRequest,
      ComponentIn: lazy(() => import("Components/Admin/all-request/index"))
    },
    {
      path: Paths.locationCheck,
      ComponentIn: lazy(() => import("Components/Admin/location-check/index"))
    },
    {
      path: Paths.locationCheck + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/location-check/view"))
    },
    {
      path: Paths.locationCheckException,
      ComponentIn: lazy(() => import("Components/Admin/location-check-exception/index"))
    },
    {
      path: Paths.locationCheckException + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/location-check-exception/view"))
    },
    {
      path: Paths.allRequest + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/all-request/view"))
    },
    {
      path: Paths.allRequest + "/update/:id",
      ComponentIn: lazy(() => import("Components/Admin/all-request/update"))
    },
    {
      path: Paths.docVerification,
      ComponentIn: lazy(() => import("Components/Admin/doc-verification/index"))
    },
    {
      path: Paths.docVerification + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/doc-verification/view"))
    },
    {
      path: Paths.furnitureSetup,
      ComponentIn: lazy(() => import("Components/Admin/furniture-setup/index"))
    },
    {
      path: Paths.furnitureSetup + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/furniture-setup/update"))
    },
    {
      path: Paths.depositcheck,
      ComponentIn: lazy(() => import("Components/Admin/deposit-check/index"))
    },
    {
      path: Paths.depositcheck + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/deposit-check/update"))
    },
    {
      path: Paths.materialDispatch,
      ComponentIn: lazy(() => import("Components/Admin/material-dispatch/index"))
    },
    {
      path: Paths.materialDispatch + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/material-dispatch/update"))
    },
    {
      path: Paths.materialHandover,
      ComponentIn: lazy(() => import("Components/Admin/material-handover/index"))
    },
    {
      path: Paths.materialHandover + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/material-handover/update"))
    },
    {
      path: Paths.manageRoles,
      ComponentIn: lazy(() => import("Components/Admin/manage-roles/index"))
    },
    {
      path: Paths.manageRoles + "/add",
      ComponentIn: lazy(() => import("Components/Admin/manage-roles/add"))
    },
    {
      path: Paths.manageRoles + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/manage-roles/update"))
    },
    {
      path: Paths.manageUsers,
      ComponentIn: lazy(() => import("Components/Admin/manage-users/index"))
    },
    {
      path: Paths.manageUsers + "/add",
      ComponentIn: lazy(() => import("Components/Admin/manage-users/add"))
    },
    {
      path: Paths.manageUsers + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/manage-users/update"))
    },
    {
      path: Paths.manageBanks,
      ComponentIn: lazy(() => import("Components/Admin/manage-banks/index"))
    },
    {
      path: Paths.manageBanks + "/add",
      ComponentIn: lazy(() => import("Components/Admin/manage-banks/add"))
    },
    {
      path: Paths.manageBanks + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/manage-banks/update"))
    },
    {
      path: Paths.rcmBankManagement,
      ComponentIn: lazy(() => import("Components/Admin/rcm-bank-managment/index"))
    },
    {
      path: Paths.rcmBankManagement + "/add",
      ComponentIn: lazy(() => import("Components/Admin/rcm-bank-managment/add"))
    },
    {
      path: Paths.rcmBankManagement + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/rcm-bank-managment/update"))
    },
    {
      path: Paths.manageBranches,
      ComponentIn: lazy(() => import("Components/Admin/manage-branches/index"))
    },
    {
      path: Paths.manageBranches + "/add",
      ComponentIn: lazy(() => import("Components/Admin/manage-branches/add"))
    },
    {
      path: Paths.manageBranches + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/manage-branches/update"))
    },
    {
      path: Paths.furnitureItem,
      ComponentIn: lazy(() => import("Components/Admin/furniture-items/index"))
    },
    {
      path: Paths.furnitureItem + "/add",
      ComponentIn: lazy(() => import("Components/Admin/furniture-items/add"))
    },
    {
      path: Paths.furnitureItem + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/furniture-items/update"))
    },

    {
      path: Paths.furnitureTemplate,
      ComponentIn: lazy(() => import("Components/Admin/furniture-template/index"))
    },
    {
      path: Paths.furnitureTemplate + "/add",
      ComponentIn: lazy(() => import("Components/Admin/furniture-template/add"))
    },
    {
      path: Paths.furnitureTemplate + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/furniture-template/update"))
    },
    {
      path: Paths.paymentManagement,
      ComponentIn: lazy(() => import("Components/Admin/payment-management/index"))
    },

    {
      path: Paths.paymentManagement + "/view/:id/:reference_id",
      ComponentIn: lazy(() => import("Components/Admin/payment-management/view"))
    },
    {
      path: Paths.paymentManagementException,
      ComponentIn: lazy(() => import("Components/Admin/payment-management-exception/index"))
    },
    {
      path: Paths.paymentManagementException + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/payment-management-exception/view"))
    },
    {
      path: Paths.notification,
      ComponentIn: lazy(() => import("Components/Shared/Notification/Notification"))
    },

    {
      path: Paths.displayWall,
      ComponentIn: lazy(() => import("Components/Admin/display-wall/index"))
    },
    {
      path: Paths.displayWall + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/display-wall/view"))
    }
  ],
  User: [
    {
      path: Paths.home,
      ComponentIn: lazy(() => import("Components/Admin/home/index"))
    },
    {
      path: Paths.home + "/view",
      ComponentIn: lazy(() => import("Components/Admin/home/view"))
    },
    {
      path: Paths.home + "/update",
      ComponentIn: lazy(() => import("Components/Admin/home/update"))
    },
    {
      path: Paths.allRequest,
      ComponentIn: lazy(() => import("Components/Admin/all-request/index"))
    },
    {
      path: Paths.locationCheck,
      ComponentIn: lazy(() => import("Components/Admin/location-check/index"))
    },
    {
      path: Paths.locationCheck + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/location-check/view"))
    },
    {
      path: Paths.locationCheckException,
      ComponentIn: lazy(() => import("Components/Admin/location-check-exception/index"))
    },
    {
      path: Paths.locationCheckException + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/location-check-exception/view"))
    },
    {
      path: Paths.allRequest + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/all-request/view"))
    },
    {
      path: Paths.allRequest + "/update/:id",
      ComponentIn: lazy(() => import("Components/Admin/all-request/update"))
    },
    {
      path: Paths.docVerification,
      ComponentIn: lazy(() => import("Components/Admin/doc-verification/index"))
    },
    {
      path: Paths.docVerification + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/doc-verification/view"))
    },
    {
      path: Paths.furnitureSetup,
      ComponentIn: lazy(() => import("Components/Admin/furniture-setup/index"))
    },
    {
      path: Paths.furnitureSetup + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/furniture-setup/update"))
    },
    {
      path: Paths.depositcheck,
      ComponentIn: lazy(() => import("Components/Admin/deposit-check/index"))
    },
    {
      path: Paths.depositcheck + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/deposit-check/update"))
    },
    {
      path: Paths.materialDispatch,
      ComponentIn: lazy(() => import("Components/Admin/material-dispatch/index"))
    },
    {
      path: Paths.materialDispatch + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/material-dispatch/update"))
    },
    {
      path: Paths.materialHandover,
      ComponentIn: lazy(() => import("Components/Admin/material-handover/index"))
    },
    {
      path: Paths.materialHandover + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/material-handover/update"))
    },
    {
      path: Paths.manageRoles,
      ComponentIn: lazy(() => import("Components/Admin/manage-roles/index"))
    },
    {
      path: Paths.manageRoles + "/add",
      ComponentIn: lazy(() => import("Components/Admin/manage-roles/add"))
    },
    {
      path: Paths.manageRoles + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/manage-roles/update"))
    },
    {
      path: Paths.manageUsers,
      ComponentIn: lazy(() => import("Components/Admin/manage-users/index"))
    },
    {
      path: Paths.manageUsers + "/add",
      ComponentIn: lazy(() => import("Components/Admin/manage-users/add"))
    },
    {
      path: Paths.manageUsers + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/manage-users/update"))
    },
    {
      path: Paths.manageBanks,
      ComponentIn: lazy(() => import("Components/Admin/manage-banks/index"))
    },
    {
      path: Paths.manageBanks + "/add",
      ComponentIn: lazy(() => import("Components/Admin/manage-banks/add"))
    },
    {
      path: Paths.manageBanks + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/manage-banks/update"))
    },
    {
      path: Paths.rcmBankManagement,
      ComponentIn: lazy(() => import("Components/Admin/rcm-bank-managment/index"))
    },
    {
      path: Paths.rcmBankManagement + "/add",
      ComponentIn: lazy(() => import("Components/Admin/rcm-bank-managment/add"))
    },
    {
      path: Paths.rcmBankManagement + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/rcm-bank-managment/update"))
    },
    {
      path: Paths.manageBranches,
      ComponentIn: lazy(() => import("Components/Admin/manage-branches/index"))
    },
    {
      path: Paths.manageBranches + "/add",
      ComponentIn: lazy(() => import("Components/Admin/manage-branches/add"))
    },
    {
      path: Paths.manageBranches + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/manage-branches/update"))
    },
    {
      path: Paths.furnitureItem,
      ComponentIn: lazy(() => import("Components/Admin/furniture-items/index"))
    },
    {
      path: Paths.furnitureItem + "/add",
      ComponentIn: lazy(() => import("Components/Admin/furniture-items/add"))
    },
    {
      path: Paths.furnitureItem + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/furniture-items/update"))
    },

    {
      path: Paths.furnitureTemplate,
      ComponentIn: lazy(() => import("Components/Admin/furniture-template/index"))
    },
    {
      path: Paths.furnitureTemplate + "/add",
      ComponentIn: lazy(() => import("Components/Admin/furniture-template/add"))
    },
    {
      path: Paths.furnitureTemplate + "/edit/:id",
      ComponentIn: lazy(() => import("Components/Admin/furniture-template/update"))
    },
    {
      path: Paths.paymentManagement,
      ComponentIn: lazy(() => import("Components/Admin/payment-management/index"))
    },
    {
      path: Paths.paymentManagement + "/view/:id/:reference_id",
      ComponentIn: lazy(() => import("Components/Admin/payment-management/view"))
    },
    {
      path: Paths.paymentManagementException,
      ComponentIn: lazy(() => import("Components/Admin/payment-management-exception/index"))
    },
    {
      path: Paths.paymentManagementException + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/payment-management-exception/view"))
    },
    {
      path: Paths.displayWall,
      ComponentIn: lazy(() => import("Components/Admin/display-wall/index"))
    },
    {
      path: Paths.displayWall + "/view/:id",
      ComponentIn: lazy(() => import("Components/Admin/display-wall/view"))
    },
    {
      path: Paths.notification,
      ComponentIn: lazy(() => import("Components/Shared/Notification/Notification"))
    }
  ],
  associate_buyer: [
    {
      path: Paths.userDashboard,
      ComponentIn: lazy(() => import("Components/PucForm/Dashboard/index"))
    },
    {
      path: Paths.userDashboard + "/view/:id",
      ComponentIn: lazy(() => import("Components/PucForm/Dashboard/view"))
    },
    {
      path: Paths.pucform + "/:id",
      ComponentIn: lazy(() => import("Components/PucForm/"))
    },
    {
      path: Paths.userPayment,
      ComponentIn: lazy(() => import("Components/PucForm/Payment/index"))
    },
    {
      path: Paths.userPayment + "/view/:id/:refId",
      ComponentIn: lazy(() => import("Components/PucForm/Payment/view"))
    },
    {
      path: Paths.pucform + "/:id",
      ComponentIn: lazy(() => import("Components/PucForm/"))
    },
    {
      path: Paths.keySoulStore + "/:id",
      ComponentIn: lazy(() => import("Components/KeySoul/"))
    },
    {
      path: Paths.displayWall + "/:id",
      ComponentIn: lazy(() => import("Components/DisplayWall/"))
    },
    {
      path: Paths.wonderworldquick + "/:id",
      ComponentIn: lazy(() => import("Components/PucForm/"))
    },
    {
      path: Paths.displayWallStore,
      ComponentIn: lazy(() => import("Components/DisplayWall/Dashboard/index"))
    },
    {
      path: Paths.userNotification,
      ComponentIn: lazy(() => import("Components/Shared/Notification/Notification"))
    }
  ]
};

export const publicRoutes = [
  {
    path: Paths.base,
    ComponentIn: lazy(() => import("Components/Authentication/login"))
  },
  {
    path: Paths.login,
    ComponentIn: lazy(() => import("Components/Authentication/login"))
  },
  {
    path: Paths.forgotpassword,
    ComponentIn: lazy(() => import("Components/ForgotPassword/ForgotPassword"))
  },
  {
    path: Paths.displayWallEcom + "/:usertoken",
    ComponentIn: lazy(() => import("Components/DisplayWall/ecomIndex"))
  },
  {
    path: Paths.nf,
    ComponentIn: lazy(() => import("Components/404/index"))
  }
];
